import { DATA_DOW_DEMO_DNA1_1 } from "./DOWDemo/105DOWDemoDNA1_1";
import { DATA_DOW_DEMO_DNA1_2 } from "./DOWDemo/106DOWDemoDNA1_2";
import { DATA_DOW_DEMO_DNA1_3 } from "./DOWDemo/107DOWDemoDNA1_3";
import { DATA_DOW_DEMO_DNA1_4 } from "./DOWDemo/108DOWDemoDNA1_4";
import { DATA_DOW_DEMO_DNA1_5 } from "./DOWDemo/109DOWDemoDNA1_5";
import { DATA_DOW_DEMO_DNA1_6 } from "./DOWDemo/110DOWDemoDNA1_6";
import { DATA_DOW_DEMO_DNA1_7 } from "./DOWDemo/111DOWDemoDNA1_7";
import { DATA_DOW_DEMO_DNA1_8 } from "./DOWDemo/112DOWDemoDNA1_8";
import { DATA_DOW_DEMO_DNA1_9 } from "./DOWDemo/113DOWDemoDNA1_9";
import { DATA_DOW_DEMO_DNA1_10 } from "./DOWDemo/114DOWDemoDNA1_10";
import { DATA_DOW_DEMO_DNA1_END } from "./DOWDemo/115DOWDemoDNA1_End";
import { DATA_INTRO_DNA1 } from "./Introduction/101DataIntroDNA1";
import { DATA_BENEFITS_DNA1_1 } from "./Introduction/102DataBenefitsDNA1_1";
import { DATA_BENEFITS_DNA1_2 } from "./Introduction/103DataBenefitsDNA1_2";
import { DATA_CHARACTERS_DNA1 } from "./Introduction/1044DataCharactersDNA1";
import { DATA_BENEFITS_DNA1_3 } from "./Introduction/104DataBenefitsDNA1_3";

export const DNA1_WORKFLOW = [
  { page: 101, type: "intro-template" as TemplateType, data: DATA_INTRO_DNA1 },
  {
    page: 102,
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_DNA1_1,
  },
  {
    page: 103,
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_DNA1_2,
  },
  {
    page: 104,
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_DNA1_3,
  },
  {
    page: 1044,
    type: "characters-template" as TemplateType,
    data: DATA_CHARACTERS_DNA1,
  },
  {
    page: 105,
    type: "journey-two-template" as TemplateType,
    data: DATA_DOW_DEMO_DNA1_1,
  },
  {
    page: 106,
    type: "journey-two-template" as TemplateType,
    data: DATA_DOW_DEMO_DNA1_2,
  },
  {
    page: 107,
    type: "journey-two-template" as TemplateType,
    data: DATA_DOW_DEMO_DNA1_3,
  },
  {
    page: 108,
    type: "journey-two-template" as TemplateType,
    data: DATA_DOW_DEMO_DNA1_4,
  },
  {
    page: 109,
    type: "journey-two-template" as TemplateType,
    data: DATA_DOW_DEMO_DNA1_5,
  },
  {
    page: 110,
    type: "journey-two-template" as TemplateType,
    data: DATA_DOW_DEMO_DNA1_6,
  },
  {
    page: 111,
    type: "journey-two-template" as TemplateType,
    data: DATA_DOW_DEMO_DNA1_7,
  },
  {
    page: 112,
    type: "video-journey-template" as TemplateType,
    data: DATA_DOW_DEMO_DNA1_8,
  },
  {
    page: 113,
    type: "video-journey-template" as TemplateType,
    data: DATA_DOW_DEMO_DNA1_9,
  },
  {
    page: 114,
    type: "video-journey-template" as TemplateType,
    data: DATA_DOW_DEMO_DNA1_10,
  },
  {
    page: 115,
    type: "end-template" as TemplateType,
    data: DATA_DOW_DEMO_DNA1_END,
  },
];
